/*
global
$
jQuery
*/

import initSelectric from "selectric";

initSelectric(window, jQuery);

const coreForms = (($) => { // eslint-disable-line

	const me = {};

	me.selectric = ((prefix) => {

		// Selectric -> http://selectric.js.org/
		$('select').selectric({
			disableOnMobile: false,
			customClass: {
			    																																							prefix,
			    																																								camelCase: false,
			},
			responsive: true,
		});

	});

	me.init = function() {};

	return me;

})(jQuery);

export { coreForms };
